import type { AIHistoryEntry } from '../types'
import { aiHistoryRepository } from '../repositories'

/** Thin history facade for the AI module. */
export class AIHistoryService {
  list(): AIHistoryEntry[] {
    return aiHistoryRepository.list()
  }

  record(type: AIHistoryEntry['type'], request: unknown, response: unknown): AIHistoryEntry {
    return aiHistoryRepository.add({
      type,
      request: JSON.stringify(request).slice(0, 4000),
      response: JSON.stringify(response).slice(0, 8000),
    })
  }

  clear(): void {
    aiHistoryRepository.clear()
  }
}

export const aiHistoryService = new AIHistoryService()
